import en from './languages/en';
import es from './languages/es';
import ptBR from './languages/ptBR';

export default {
  en,
  es,
  'pt-BR': ptBR,
};



/** WEBPACK FOOTER **
 ** ./src/i18n/messages/index.js
 **/